export const SocialMediaLinks = {
  Linkedin: 'https://www.linkedin.com/company/oijpcr/',

  Twitter: 'https://twitter.com/oijpcr',

  Instagram: 'https://www.instagram.com/oijpcr_/',
}

